if (!customElements.get('link-bio-page')) {
  class LinkBioPage extends HTMLElement {
    connectedCallback() {
      if (this.onClick) return;
      this.scope = this.closest('main, [role="main"]') || this.parentElement;
      this.onClick = event => {
        const tab = event.target.closest('[data-link-bio-tab]');
        if (tab && this.contains(tab)) this.select(tab.dataset.linkBioTab, true);
      };
      this.onKeydown = event => {
        const tab = event.target.closest('[data-link-bio-tab]');
        const tabs = [...this.querySelectorAll('[data-link-bio-tab]')];
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1
          : (tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[index].focus();
        this.select(tabs[index].dataset.linkBioTab, true);
      };
      this.onHashChange = () => this.select(location.hash === '#products' ? 'products' : 'links');
      this.onBlockSelect = event => {
        const panel = event.target.closest('[data-link-bio-panel]');
        if (panel && this.contains(panel)) this.select(panel.dataset.linkBioPanel);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      window.addEventListener('hashchange', this.onHashChange);
      this.select(this.scope.dataset.linkBioView || (location.hash === '#products' ? 'products' : 'links'));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      window.removeEventListener('hashchange', this.onHashChange);
      this.onClick = null;
    }

    select(view, updateHistory = false) {
      if (!['links', 'products'].includes(view)) return;
      this.scope.dataset.linkBioView = view;
      const pages = [...this.scope.querySelectorAll('link-bio-page')];
      pages.forEach(page => {
        const activePanel = page.querySelector(`[data-link-bio-panel="${view}"]`);
        page.hidden = !page.querySelector('[data-link-bio-tab]') && activePanel?.dataset.empty === 'true';
        page.querySelectorAll('[data-link-bio-panel]').forEach(panel => {
          panel.hidden = panel.dataset.linkBioPanel !== view;
        });
        page.querySelectorAll('[data-link-bio-tab]').forEach(tab => {
          const selected = tab.dataset.linkBioTab === view;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          const ids = pages.map(item => item.querySelector(`[data-link-bio-panel="${tab.dataset.linkBioTab}"]`)?.id).filter(Boolean);
          tab.setAttribute('aria-controls', ids.join(' '));
        });
      });
      if (updateHistory) history.replaceState(history.state, '', view === 'products' ? '#products' : '#links');
    }
  }
  customElements.define('link-bio-page', LinkBioPage);
}
